module.exports = __webpack_public_path__ + "static/media/mauricio.297f59b4.jpg";